import upload from "@/services/upload";
import {v4 as uuidv4} from "uuid";
import updateCategory from "@/services/CategoryService/updateCategory";
import addCategory from "@/services/CategoryService/addCategory";
import React from "react";
import getNextProductData from "./getNextProductData";
import createProduct from "@/services/ProductService/createProduct";
import assignBundleItems from "@/services/ProductService/assignBundleItems";
import store from "@/store";
import {snapshot} from "valtio";
import updateProductInLocal from "@/services/ProductService/updateProductInLocal";
import {ProductData} from "@/types/product";

const createProductForBundleStates = {



    product: {
        main: async (data: any, defaultData: any) => {
            return await getNextProductData(defaultData.productId, defaultData.productForm)
        },
        startMessage: () => 'Prepare new product ...',
        errorMessage: () => 'Prepare new product failed :('
    },




    image: {
        main: async (data: any, defaultData: any) => {
            console.log(data)
            console.log(defaultData)
            const image = data.product?.["2d_image_url"]
            if (image?.url) {
                return image.url
            } else {
                return await upload({
                    file: image?.string,
                    fileName: `product_${data.product.sku}_${uuidv4()}.${image?.fileExtension}`,
                    folderName: `products`,
                })

            }
        },
        startMessage: () => 'Upload thumbnail ...',
        errorMessage: () => 'Upload thumbnail failed :('
    },


    requestData: {
        main: async (data: any, defaultData: any) => {
            return {
                ...data?.product,
                "2d_image_url": data?.image,
                //"product_id": defaultData?.productId
            }
        },
        startMessage: () => 'Save thumbnail ...',
    },



    createProduct: {
        main: async (data: any, defaultData: any) => {
            console.log("data.requestData", data.requestData)
            const create =  await createProduct(data.requestData)
            if (create) {
                return create
            } else {
                throw new Error('Create Product failed :(')
            }
        },
        startMessage: () => 'Create Product ...',
        errorMessage: () => 'Create Product failed :('
    },


    assignBundleItem: {
        main: async (data: any, defaultData: any) => {
            console.log("data-----", data)
            const assign =  await assignBundleItems([
                {
                    product_id: data.createProduct,
                    quantity: defaultData.productForm.quantity
                }
            ], defaultData.productId);
            if (assign) {
                return assign
            } else {
                throw new Error('Assign bundle item failed :(')
            }
        },
        startMessage: () => 'Assign bundle item ...',
        errorMessage: () => 'Assign bundle item failed :('
    },
    updateProductList: {
        main: async (data: any, defaultData: any) => {
            let {products} = snapshot(store);
            const newProduct = {
                ...data.requestData,
                product_id: data.createProduct.id
            }
            //const otherProducts = products.filter(p => p.product_id !== defaultData.productId)
            let currentProduct = products.find(
                p => p.product_id === defaultData.productId
            ) as ProductData | undefined;

            if (!currentProduct) return;

            const updateCurrentProduct:ProductData = {
                ...currentProduct,
                is_bundle: true,
            }

            updateProductInLocal(updateCurrentProduct, [newProduct])
        },
        startMessage: () => `Load products ...`,
        errorMessage: () => `Loading failed :(`
    }



}

export default createProductForBundleStates